import type { Secretary } from "@/types/secretaries"
import { API_ROOT, HttpClient } from "@/api/httpClient"

export interface SecretaryPayload {
	email: string
	name: string
	surname: string
	phone: string
	/** 1: send, 0: don't send */
	send_invitation: 0 | 1
}

export default {
	list() {
		return HttpClient.get<Secretary[]>(`${API_ROOT}/medical-centers/secretaries`)
	},
	create(payload: SecretaryPayload) {
		return HttpClient.post<Secretary>(`${API_ROOT}/medical-centers/secretaries`, payload)
	},
	update(secretaryId: number, payload: SecretaryPayload) {
		return HttpClient.put<Secretary>(`${API_ROOT}/medical-centers/secretaries/${secretaryId}`, payload)
	},
	delete(secretaryId: number) {
		return HttpClient.delete(`${API_ROOT}/medical-centers/secretaries/${secretaryId}`)
	}
}
